import * as React from 'react';
import { t } from '@moovly/i18n';
import { Button, Spinner } from '@moovly/ui';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/rootStore';
import useUserLicense from '../../users/hooks/useUserLicense';
import GrantSubscription from '../components/AssignSubscription/AssignSubscription';
import useLicenses from '../hooks/useLicenses';
import useConsentOrderModal from '../modals/useConsentOrderModal';
import LicenseSlice, { grantUserLicense, revokeLicense, orderLicense } from '../store/licenses.store';
import { useSetting } from '@moovly/moovly-settings';
import { useSearchParams } from 'react-router-dom';

const SubscriptionContainer: React.FC<{ userId: string }> = ({ userId }) => {
  const dispatch = useDispatch<any>();
  const puchaseGroupLicense = useSetting('license.purchase_group_license');
  const payment = useSelector((state: RootState) => state.licenses.payment);
  const [contractId, setContractId] = React.useState<string>();
  const { contracts } = useLicenses();
  const { license, isLoading } = useUserLicense(userId);
  const [searchParams] = useSearchParams();
  const handleGrantLicense = React.useCallback(
    (contractId: string, licenseId: string) =>
      dispatch(
        grantUserLicense({
          contractId,
          licenseId,
          userId,
        })
      ),
    [dispatch, userId]
  );

  const handleRevokeLicense = React.useCallback(
    (silence = false) => {
      if (!!license?.id) {
        dispatch(
          revokeLicense({
            licenseId: license?.id!,
            contractId: license.contract.id,
            silence,
          })
        );
      }
    },
    [dispatch, license]
  );
  React.useEffect(() => {
    if (searchParams.get('autoRevoke') && !isLoading && license && license.is_expired) {
      handleRevokeLicense(true);
    }
  }, [searchParams, isLoading, license]);
  const handleOrderAndAssignNewLicense = React.useCallback(
    (contractId: string) => {
      setContractId(contractId);
      dispatch(
        orderLicense({
          contractId: contractId,
          userId,
          amount: 1,
          consentedWarning: false,
        })
      );
    },
    [dispatch, userId]
  );

  const { ConsentOrderModal, openConsentOrderModal } = useConsentOrderModal();
  React.useEffect(() => {
    if (payment?.error && !!payment.warning && contractId) {
      openConsentOrderModal(() => {
        dispatch(
          orderLicense({
            contractId: contractId,
            userId,
            amount: 1,
            consentedWarning: true,
          })
        );
        dispatch(LicenseSlice.actions.resetPayment());
      });
    }
  }, [contractId, dispatch, openConsentOrderModal, payment, userId]);
  if (isLoading) return <Spinner />;
  return (
    <>
      {!!license && <Button color="blue" label={t('licenseManagement.revoke')} onClick={() => handleRevokeLicense()} />}
      {!license && (
        <>
          <GrantSubscription
            userId={userId}
            license={license}
            contracts={contracts}
            onGrantLicense={handleGrantLicense}
            canPurchaseAndAssign={puchaseGroupLicense !== 'deny'}
            onOrderAndAssignNewLicense={handleOrderAndAssignNewLicense}
          />
          <ConsentOrderModal description={payment.error || 'consent please'} />
        </>
      )}
    </>
  );
};

export default SubscriptionContainer;
